module.exports = __webpack_public_path__ + "img/cajaCerrada.be8a4b8b.svg";